import React from 'react'
import styled from 'styled-components'
import theme from 'src/theme'
import { typography, color, Icon } from '@primer-io/goat'
import { Bolt, CodeClose, CreditCard, Dollar, Globe } from '@primer-io/goat-icons'

export const Root = styled.div.attrs({ className: 'block_like' })``

const HeaderRoot = styled.div`
	background: var(--color-background);
	padding: 10px 24px;

	display: grid;
	grid-template-columns: 1fr;
	gap: 0px;
	justify-content: start;
	align-items: start;

	${p => p.theme.above('medium')`
		grid-template-columns: 30% 70%;
	`}

	div {
		${theme.typography.scale.caption2.regular}
	}
`

export const DefinitionListRoot = styled.dl`
	display: grid;
	grid-template-columns: 1fr;
	gap: 0px;
	justify-content: stretch;
	align-items: stretch;

	${theme.typography.scale.body1.regular}

	${p => p.showBorderTop && 'border-top: 1px var(--color-lightGrey) solid;'}

	${p => p.theme.above('medium')`
		grid-template-columns: 30% 70%;
	`}
`

const DtStyled = styled.dt`
	display: block;
	padding: 24px 0px 16px 0px;
	margin: 0px;

	${p => p.theme.above('medium')`
		padding: 24px 0px;
		border-bottom: 1px var(--color-lightGrey) solid;
	`}
`
const DdStyled = styled.dd`
	display: block;
	padding: 0px 0px 24px 0px;
	margin: 0px;

	border-bottom: 1px var(--color-lightGrey) solid;

	${p => p.theme.above('medium')`
		padding: 24px;
	`}

	& > ul:last-child {
		margin-bottom: 0px !important;
	}
`

const DTHeaderStyled = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;

	${typography('title-large')}
	color: ${color('gray-700')};
`

const icons = {
	CreditCard: CreditCard,
	Zap: Bolt,
	DollarSign: Dollar,
	Globe: Globe,
	Code: CodeClose,
}

export const DT = ({ children }) => <DtStyled>{children}</DtStyled>
export const DD = ({ children }) => <DdStyled>{children}</DdStyled>
export const DTHeader = ({ children, iconName, icon }) => (
	<DT>
		<DTHeaderStyled>
			{iconName && <Icon as={icon ?? icons[iconName]} />}
			<div>{children}</div>
		</DTHeaderStyled>
	</DT>
)

const DefinitionList = ({ children, subject, explanation }) => {
	const hasHeader = subject && explanation

	return (
		<Root>
			{hasHeader && (
				<HeaderRoot>
					<div>{subject}</div>
					<div>{explanation}</div>
				</HeaderRoot>
			)}
			<DefinitionListRoot showBorderTop={!hasHeader}>{children}</DefinitionListRoot>
		</Root>
	)
}

export default DefinitionList
